var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 12,
    viewBox: "0 0 32 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74262 4.384C8.74262 5.03467 8.59329 5.632 8.29462 6.176C7.99596 6.70933 7.53729 7.14133 6.91862 7.472C6.29996 7.80267 5.53196 7.968 4.61462 7.968H2.91862V12H0.182624V0.768H4.61462C5.51062 0.768 6.26796 0.922666 6.88662 1.232C7.50529 1.54133 7.96929 1.968 8.27862 2.512C8.58796 3.056 8.74262 3.68 8.74262 4.384ZM4.40662 5.792C4.92929 5.792 5.31862 5.66933 5.57462 5.424C5.83062 5.17867 5.95862 4.832 5.95862 4.384C5.95862 3.936 5.83062 3.58933 5.57462 3.344C5.31862 3.09867 4.92929 2.976 4.40662 2.976H2.91862V5.792H4.40662ZM17.359 10.016H13.167L12.495 12H9.631L13.695 0.768H16.863L20.927 12H18.031L17.359 10.016ZM16.655 7.904L15.263 3.792L13.887 7.904H16.655ZM28.0919 12L25.7559 7.76H25.0999V12H22.3639V0.768H26.9559C27.8412 0.768 28.5932 0.922666 29.2119 1.232C29.8412 1.54133 30.3105 1.968 30.6199 2.512C30.9292 3.04533 31.0839 3.64267 31.0839 4.304C31.0839 5.05067 30.8705 5.71733 30.4439 6.304C30.0279 6.89067 29.4092 7.30667 28.5879 7.552L31.1799 12H28.0919ZM25.0999 5.824H26.7959C27.2972 5.824 27.6705 5.70133 27.9159 5.456C28.1719 5.21067 28.2999 4.864 28.2999 4.416C28.2999 3.98933 28.1719 3.65333 27.9159 3.408C27.6705 3.16267 27.2972 3.04 26.7959 3.04H25.0999V5.824Z",
    fill: "#F82873"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPar);
export default __webpack_public_path__ + "static/media/PAR.65d260a3ee3cec6b314815233708f618.svg";
export { ForwardRef as ReactComponent };